import { render, staticRenderFns } from "./ProgressHeader.vue?vue&type=template&id=97d5dfd0&lang=pug&"
import script from "./ProgressHeader.vue?vue&type=script&lang=ts&"
export * from "./ProgressHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports